<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <b-tabs>
          <b-tab title="Active">
            <OptionOne />
          </b-tab>
          <b-tab title="Archived">
            <TerminatedEmployee />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import OptionOne from "./optionOne.vue";
import TerminatedEmployee from "./terminatedEmployee.vue";
export default {
  name: "governanceDashboard",
  components: {
    OptionOne,
    TerminatedEmployee,
  },
};
</script>

<style>
</style>